<template>
  <v-menu open-on-hover top rounded="xl">
    <template v-slot:activator="{ on, attrs }">
      <img
        v-bind="attrs"
        v-on="on"
        class="image-preview"
        loading="lazy"
        :shadow="false"
        :src="getProductPictureUrlById(product.pictureId)"
      />
    </template>

    <product-card
      showQty
      :product="product"
      :allow-add-to-cart="false"
    ></product-card>
  </v-menu>
</template>
<script>
import backendService from "@/services/backend-service";
import ProductCard from "./ProductCard.vue";
export default {
  name: "ProductDialog",
  components: { "product-card": ProductCard },
  props: {
    product: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  methods: {
    getProductPictureUrlById(imageId) {
      if (!imageId) return;
      return backendService.getProductPictureUrlById(imageId);
    },
  },
};
</script>
<style scoped>
.image-preview {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  margin-bottom: 5px;
  margin-top: 5px;
  object-fit: contain;
  float: left;
  image-rendering: smooth;
}
</style>
